// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  assignmentId: __t.u64().name("assignment_id"),
  stepId: __t.string().name("step_id"),
  attemptNumber: __t.u32().name("attempt_number"),
  enteredAt: __t.timestamp().name("entered_at"),
  exitedAt: __t.option(__t.timestamp()).name("exited_at"),
  timeSpentSeconds: __t.option(__t.u32()).name("time_spent_seconds"),
});
